'use client'

import Link from 'next/link'
import { useTheme } from '@/contexts/ThemeContext'

export default function BeginnerGuidePage() {
  const { theme } = useTheme()

  const guides = [
    { title: '프리다이빙이란?', href: '/guide/what-is-freediving', desc: '프리다이빙의 정의와 매력, 스쿠버다이빙과의 차이점을 알아봅니다.' },
    { title: '자격증 종류', href: '/guide/certifications', desc: 'AIDA, PADI, SSI 등 협회별 자격증 종류와 레벨을 비교합니다.' },
    { title: '첫 강습 준비물', href: '/guide/first-class-preparation', desc: '프리다이빙 첫 강습 전 준비해야 할 물품과 마음가짐을 안내합니다.' },
    { title: '강습 비용 안내', href: '/guide/training-cost', desc: '레벨별 강습 비용과 추가 비용에 대해 안내합니다.' },
    { title: '풀다이빙 vs 바다다이빙', href: '/guide/pool-vs-ocean', desc: '풀장과 바다에서의 다이빙 차이점과 각각의 장단점을 비교합니다.' },
    { title: '호흡법 가이드', href: '/guide/breathing-techniques', desc: '프리다이빙에 필수적인 호흡 테크닉과 연습 방법을 알아봅니다.' },
  ]

  return (
    <div className={`min-h-screen py-2 xxs:py-1.5 px-3 xxs:px-2 ${
      theme === 'light' ? 'bg-white' : 'bg-gray-900'
    }`}>
      <div className="max-w-6xl mx-auto">
        <div className="mb-3 xxs:mb-2">
          <Link
            href="/guide"
            className={`text-xs xxs:text-[10px] ${
              theme === 'light' ? 'text-blue-600 hover:text-blue-700' : 'text-blue-400 hover:text-blue-300'
            }`}
          >
            ← 전체 가이드
          </Link>
        </div>

        <h1 className={`text-base xxs:text-sm font-bold mb-1.5 xxs:mb-1 ${
          theme === 'light' ? 'text-gray-900' : 'text-white'
        }`}>입문 가이드</h1>
        <p className={`text-xs xxs:text-[10px] mb-3 xxs:mb-2 ${
          theme === 'light' ? 'text-gray-600' : 'text-gray-400'
        }`}>
          프리다이빙을 처음 시작하는 분들을 위한 기초 가이드입니다.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 xxs:gap-1.5">
          {guides.map((guide) => (
            <Link
              key={guide.href}
              href={guide.href}
              className={`p-3 xxs:p-2 rounded-lg shadow-md hover:shadow-xl transition-all hover:scale-105 ${
                theme === 'light'
                  ? 'bg-white border border-gray-200'
                  : 'bg-gray-800 border border-gray-700'
              }`}
            >
              <h3 className={`text-sm xxs:text-xs font-bold mb-1 xxs:mb-0.5 ${
                theme === 'light' ? 'text-gray-900' : 'text-white'
              }`}>{guide.title}</h3>
              <p className={`text-xs xxs:text-[10px] ${
                theme === 'light' ? 'text-gray-600' : 'text-gray-400'
              }`}>{guide.desc}</p>
            </Link>
          ))}
        </div>

        <div className={`mt-3 xxs:mt-2 p-3 xxs:p-2 rounded-lg ${
          theme === 'light'
            ? 'bg-blue-50 border border-gray-200'
            : 'bg-blue-900/20 border border-gray-700'
        }`}>
          <h3 className={`font-bold text-sm xxs:text-xs mb-1.5 xxs:mb-1 ${
            theme === 'light' ? 'text-gray-900' : 'text-white'
          }`}>💡 입문자 팁</h3>
          <ul className={`text-xs xxs:text-[10px] space-y-1 xxs:space-y-0.5 ${
            theme === 'light' ? 'text-gray-600' : 'text-gray-400'
          }`}>
            <li>• 처음에는 반드시 전문 강사에게 배우세요</li>
            <li>• 혼자 연습하지 말고 항상 버디와 함께하세요</li>
            <li>• 장비는 강습 후 천천히 구매해도 됩니다</li>
            <li>• 수영을 못해도 프리다이빙을 배울 수 있습니다</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
